import { ApiError } from '@datocms/cma-client-browser';

const STALE_ITEM_VERSION = 'STALE_ITEM_VERSION';

/**
 * Optimistic-lock conflict from a Dato CMA write, from either client:
 * the direct CMA `Client` throws an `ApiError`; `ApiClient` (arbor-v1 proxy)
 * throws a plain `Error` with Dato's error payload stringified into the message.
 */
export function isStaleVersionError(error: unknown): boolean {
  if (error instanceof ApiError) {
    return !!error.findError(STALE_ITEM_VERSION);
  }
  return error instanceof Error && error.message.includes(STALE_ITEM_VERSION);
}
